import { render, staticRenderFns } from "./TheLessonEvidence.vue?vue&type=template&id=0b82755c&scoped=true&"
import script from "./TheLessonEvidence.vue?vue&type=script&lang=js&"
export * from "./TheLessonEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82755c",
  null
  
)

export default component.exports